import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function UserArticlePage() {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState('ALL');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [limit] = useState(9);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showPDFModal, setShowPDFModal] = useState(false);

  const [searchInput, setSearchInput] = useState('');
  const [categoryInput, setCategoryInput] = useState('ALL');

  const fetchCategories = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL+'/user/categories', {
        params: { start: 0, length: 100 },
        withCredentials: true,
      });
      setCategories(res.data.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get(process.env.REACT_APP_API_BASE_URL+'/user/articles', {
        params: {
          start: page * limit,
          length: limit,
          search,
          category: category !== 'ALL' ? category : undefined,
        },
        withCredentials: true
      });
      setData(res.data.data);
      setTotal(res.data.recordsFiltered);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, search, category]);

  const openModal = (article) => {
    setSelectedArticle(article);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedArticle(null);
  };

  const openPDFModal = () => {
    setShowPDFModal(true);
  };

  const closePDFModal = () => {
    setShowPDFModal(false);
  };

  return (
    <div className="container-fluid px-0">
      <h3 className="mb-4">Artikel</h3>

      <div className="row">
        <div className="col-xl-3 col-lg-4 col-md-12 col-sm-12 mb-3">
          <div className="card shadow-sm">
            <div className="card-header">
              <i className="fa fa-filter me-2"></i> Filter
            </div>
            <div className="card-body">
              <div className="mb-2">
                <label>Kategori</label>
                    <select
                        className="form-control"
                        value={categoryInput}
                        onChange={(e) => setCategoryInput(e.target.value)}
                    >
                        <option value="ALL">Semua</option>
                        {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                            {cat.name}
                        </option>
                        ))}
                    </select>
                    </div>
                    <div>
                    <label>Pencarian</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Cari judul / penulis"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                    />
                    </div>
                    <div className='mt-3'>
                    <button
                        className="btn btn-dark form-control"
                        onClick={() => {
                        setSearch(searchInput);
                        setCategory(categoryInput);
                        setPage(0);
                        }}
                    >
                        <i className='fa fa-search'></i> Cari
                    </button>
                </div>
            </div>
          </div>
        </div>

        <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12">
          {loading ? (
            <div className="text-center mt-5">
              <div className="spinner-border"></div>
            </div>
          ) : (
            <>
              <div className="row">
                <h4 className='mb-3'>Menampilkan <b className='text-dark'>{total}</b> artikel</h4>
                {data.map((item) => (
                  <div className="col-md-4 mb-3" key={item.id}>
                    <div
                      className="card h-100 border-dark shadow-sm"
                      style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                      onClick={() => openModal(item)}
                      onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.03)'}
                      onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
                      <div className="card-body">

                        {/* <center>
                            <i className='fa fa-book fa-4x mb-2'></i>
                        </center>

                        <br/> */}
                        <small className="text-muted">{item.category}</small>
                        <b
                        className="card-title"
                        style={{
                            fontWeight: 'bold',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                        >
                        {item.title}
                        </b>
                        <small className="text-dark small">{item.author}</small><br/>
                        <small className="small">{item.tahun_publikasi}</small>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <small className='text-muted'>
                    Page: {page + 1}/{Math.ceil(total / limit)}
                </small>
                <div>
                  <button className="btn btn-sm btn-secondary me-2" disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
                  <button className="btn btn-sm btn-secondary" disabled={(page + 1) * limit >= total} onClick={() => setPage(page + 1)}>Next</button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {showModal && selectedArticle && (
        <div className="modal show fade d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedArticle.title}</h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <p><strong>Kategori:</strong> {selectedArticle.category}</p>
                <p><strong>Abstrak:</strong> {selectedArticle.abstrak}</p>
                <p><strong>Author:</strong> {selectedArticle.author}</p>
                <p><strong>Tahun Publikasi:</strong> {selectedArticle.tahun_publikasi}</p>
                <p><strong>Last Update:</strong> {new Date(selectedArticle.updated_at).toLocaleString()}</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-outline-dark" onClick={openPDFModal}><i className="fa fa-eye me-1"></i> Lihat File</button>
                <button type="button" className="btn btn-secondary" onClick={closeModal}>Tutup</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPDFModal && selectedArticle && (
        <div className="modal show fade d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl" style={{ maxWidth: '95%' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Preview File</h5>
                <button type="button" className="btn-close" onClick={closePDFModal}></button>
              </div>
              <div className="modal-body" style={{ height: '80vh' }}>
                <iframe
                  title="PDF Preview"
                  src={`${process.env.REACT_APP_API_BASE_URL}/user/preview/article/${selectedArticle.file}`}
                  width="100%"
                  height="100%"
                  frameBorder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserArticlePage;
